import React from 'react';
import { IconProps } from '../types/types';

const LINK: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 37.8 43.6" role="img" {...props}><g data-name="Layer 2"><path d="m18.9 0-4 2.3L4 8.6l-4 2.3v21.8L4 35l11 6.3 4 2.3 4-2.3L33.8 35l4-2.3V10.9l-4-2.3-10.9-6.3ZM8 28.1V15.5l10.9-6.3 10.9 6.3v12.6l-10.9 6.3Z" style={{fill: '#2a5ada'}} data-name="Layer 1"/></g></svg>
);

export default LINK;
